"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
/* eslint-disable no-param-reassign */
const lodash_1 = __importDefault(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const placeHolderImplementation = ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
    (0, common_1.debugLog)({
        concentrationReceivables,
        valueConfig,
        totalConcentrationExposure,
    });
    (0, common_1.finleyAssert)(false, 'pointer method is not implemented.');
};
exports.concentrationLimitPointerMethods = [
    {
        method: 'cherryCrossRiverBank1.singleState',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit cherryCrossRiverBank1.singleState`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            (0, common_1.finleyAssert)(lodash_1.default.every(concentrationReceivables, (rec) => lodash_1.default.isString(rec.baseFields.state)), new common_1.error.FinleyError('baseFields.state must be defined to run cherryCrossRiverBank1.singleState'));
            const groupedByState = lodash_1.default.groupBy(concentrationReceivables, (rec) => rec.baseFields.state);
            const standardBorrowingBaseReductions = lodash_1.default.map(lodash_1.default.values(groupedByState), (receivables) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType,
                });
            });
            let concentrationAmount = 0;
            const concentrationKickouts = lodash_1.default.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                lodash_1.default.forEach(lodash_1.default.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!result[finleyReceivableId]) {
                        result[finleyReceivableId] = 0;
                    }
                    result[finleyReceivableId] += kickout;
                    return true;
                });
                return result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
    {
        method: 'cherryCrossRiverBank1.singleMerchant',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit cherryCrossRiverBank1.singleMerchant`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            (0, common_1.finleyAssert)(lodash_1.default.every(concentrationReceivables, (rec) => lodash_1.default.isString(rec.baseFields.merchant_name)), new common_1.error.FinleyError('baseFields.merchant_name must be defined to run cherryCrossRiverBank1.merchant_name'));
            const groupedByMerchant = lodash_1.default.groupBy(concentrationReceivables, (rec) => rec.baseFields.merchant_name);
            const standardBorrowingBaseReductions = lodash_1.default.map(lodash_1.default.values(groupedByMerchant), (receivables) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType,
                });
            });
            let concentrationAmount = 0;
            const concentrationKickouts = lodash_1.default.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                lodash_1.default.forEach(lodash_1.default.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!result[finleyReceivableId]) {
                        result[finleyReceivableId] = 0;
                    }
                    result[finleyReceivableId] += kickout;
                    return true;
                });
                return result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
    // Cherry has legacy CA utilizing to these pointer methods
    // these cannot be deleted.
    {
        method: 'cherryCrossRiverBank1.minimumWaInterestRate',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumWaRemainingTerm',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumAveragePrincipleBalance',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumAttributableToAnySingleMerchant',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumAttributableTo3HighestConcentrationMerchants',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumRelatedObligorsLocatedInASingleState',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumRelatedObligorsLocatedIn3StatesWithHighestConcentrationOfObligors',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumNotOriginatedByTheBankPartnerOriginator',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumRelatedObligorsNotHavingEnabledAchAutopay',
        pointerImplementation: placeHolderImplementation,
    },
    {
        method: 'cherryCrossRiverBank1.maximumRemainingTermGreaterThan24Months',
        pointerImplementation: placeHolderImplementation,
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map